import React from "react";
import { Form, Button } from 'react-bootstrap';
import { useForm, SubmitHandler } from "react-hook-form";
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Icon from 'react-bootstrap-icons';
import { forgotPasswordApi } from '../services/api.js'
import { LocationInterface } from '../types/customTypes.js';
import '../assets/styles/resetPassword.scss';

type FormValues = {
    email: string;
};

// eslint-disable-next-line
const ForgetPassword:React.FC<LocationInterface> = (_props:LocationInterface) => {
    const { register, handleSubmit } = useForm<FormValues>();

    const onSubmit: SubmitHandler<FormValues> = data => {
        forgetPassword(data);
    }

    const forgetPassword = (data) => {
        forgotPasswordApi(data.email).then(async (response) => {
            const msg = await response.json();
            if (response.ok) toast.success(msg);
            else toast.error(msg);
        }).catch(err => toast.error(err.toString()));
    };

    return (
        <div className="row mt-5">
            <div className="col-md-4 col-sm-3 col-2"></div>
            <Form className="form border shadow col-md-4 p-3 col-sm-6 col-8" data-testid="forgotPasswordForm" id="forgotPasswordForm" onSubmit={handleSubmit(onSubmit)}>
                <div className="text-center mt-5"><Icon.LockFill size={80} /></div>
                <div id="heading" className="title text-center"> Forgot Password? </div>
                <Form.Group className="mb-3 mx-4">
                    <Form.Label > Email </Form.Label>
                    <Form.Control type="email" name="email" data-testid="email" id="email" placeholder="Enter Email" {...register("email")}
                        onInvalid={e => (e.target as HTMLInputElement).setCustomValidity('Please enter your e-mail address')}
                        onInput={e => (e.target as HTMLInputElement).setCustomValidity('')} required />
                </Form.Group>
                <div className="text text-center m-5">
                    <Link to="/login" id="backButton" data-testid="backButton" className="btn btn-secondary me-2"> Back </Link>
                    <Button id="submit" data-testid="submit" className="btn-primary" type="submit"> Submit </Button>
                </div>
            </Form>
            <div className="col-md-4 col-sm-3 col-2"></div>
        </div>
    );
};

export default ForgetPassword;
